// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__23pS2","addWidgetButton":"Header_addWidgetButton__2LQNu","dashboardTabs":"Header_dashboardTabs__3Deg4","active":"Header_active__2Na9R"};